export const INITIAL_SETTINGS_CONFIGURATION = {
  initialSetupComplete: false,
};

export type SettingsConfigurationStoreType = {
  initialSetupComplete: boolean;
};
